import { Box, Text } from '@factorialco/deprecated-design-system'
import { RawTag } from '@factorialco/factorial-one-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import EmptyState from 'modules/job_catalog/components/TreeNodeAttributes/EmptyState'
import {
  DEFAULT_CATEGORIES,
  NODE_TYPES,
  getTextFromNodeType as getNodeTypeLabel,
  isNodeType,
  nodeTypeIcon,
} from 'modules/job_catalog/lib/nodesUtils'
import { type NodeAttribute } from 'modules/job_catalog/pages/TreeNodePage/types'

interface CompetenciesAttributesProps {
  items: NodeAttribute[]
}

const CompetenciesAttribute = ({ item }: { item: NodeAttribute }) => {
  const { title, description, assesment_text } = JSON.parse(item.serializedValue)

  const nodeType = isNodeType(item.definedAt) ? item.definedAt : NODE_TYPES.ROOT

  const icon = nodeTypeIcon(nodeType)
  const label = getNodeTypeLabel(nodeType)

  return (
    <Box key={item.id} gap="s4">
      <Box flexDirection="row" justifyContent="spaceBetween" paddingRight="s16">
        <Text.Normal weight="semibold" size="200" color="grey1000">
          {title}
        </Text.Normal>
        <RawTag text={label} icon={icon} />
      </Box>
      <Text.Normal weight="normal" size="200" color="grey800">
        {description}
      </Text.Normal>
      <Text.Normal weight="normal" size="200" color="grey800">
        {assesment_text}
      </Text.Normal>
    </Box>
  )
}

const CompetenciesAttributes = ({ items }: CompetenciesAttributesProps) => {
  if (!items || items.length === 0) {
    return <EmptyState category={DEFAULT_CATEGORIES.COMPETENCIES} />
  }

  return (
    <Box paddingX="s24" gap="s20">
      <Text.Normal weight="semibold" size="200" color="grey800">
        {i18n.t('job_catalog.nodes.competency.multiple')}
      </Text.Normal>

      {items.map((item) => (
        <CompetenciesAttribute key={item.id} item={item} />
      ))}
    </Box>
  )
}

export default CompetenciesAttributes
